import { applyOverrides, otherContactCard as baseCard } from '../../../shared';

export const otherContactCard = applyOverrides(baseCard, {
  hideByDefault: false,
  addText: 'Other',
  fields: {
    role: {
      placeholderText: 'Property manager, Assistant, etc',
    },
  },
});
